import Plus from "assets/img/svg/plus";
import StyledButton from "components/shared/StyledButton";
import { getPeriodName } from "helpers/utils";
import { useTranslation } from "react-i18next";
import type { TPeriod } from "store/periodStore";

interface SubscriptionManagementModalHeaderProps {
    selectedPeriod: TPeriod;
    isProcessingJobInProgress: boolean;
    isEditable: boolean;
    onOpenImport?: () => void;
}

const SubscriptionManagementModalHeader = ({
    selectedPeriod,
    isProcessingJobInProgress,
    isEditable,
    onOpenImport,
}: SubscriptionManagementModalHeaderProps) => {
    const [t] = useTranslation();

    const periodName = getPeriodName({ period: selectedPeriod, format: "month" });

    return (
        <div
            className="modal-header"
            style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}
        >
            <div>
                <h2>{t("Management.ManageSubscription")}</h2>
                <p style={{ fontSize: "14px", color: "#666", marginTop: "4px" }}>
                    {t("Common.CurrentPeriod")} : {periodName}
                </p>
            </div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    minWidth: "200px",
                    justifyContent: "flex-end",
                    minHeight: "40px",
                }}
            >
                {onOpenImport && isEditable && (
                    <StyledButton buttonType="secondary" onClick={onOpenImport} disabled={isProcessingJobInProgress}>
                        <Plus />
                        {t("Management.ImportSubscriptionData")}
                    </StyledButton>
                )}
            </div>
        </div>
    );
};

export default SubscriptionManagementModalHeader;
